// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"431166b1","302":"cbadc282","332":"d78ca750","968":"d4d58526"}[chunkId] + ".chunk.js";
};